var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoEpgGridView = function SvgIcoEpgGridView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.364,
    cy: 1.364,
    r: 1.364,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 26.91 8.894)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.727,
    height: 2.727,
    fill: "#fff",
    rx: 1.364,
    transform: "matrix(-1 0 0 1 22.818 8.894)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.682,
    height: 2.727,
    x: 14.227,
    y: 12.984,
    fill: "#fff",
    rx: 1.364
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.045,
    height: 2.727,
    x: 5.091,
    y: 12.984,
    fill: "#fff",
    rx: 1.364
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.682,
    height: 2.727,
    x: 14.227,
    y: 21.166,
    fill: "#fff",
    rx: 1.364
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.045,
    height: 2.727,
    x: 5.091,
    y: 21.166,
    fill: "#fff",
    rx: 1.364
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 12.682,
    height: 2.727,
    fill: "#fff",
    rx: 1.364,
    transform: "matrix(-1 0 0 1 17.773 17.076)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8.045,
    height: 2.727,
    fill: "#fff",
    rx: 1.364,
    transform: "matrix(-1 0 0 1 26.91 17.076)"
  })));
};
export default SvgIcoEpgGridView;